var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g({attrs:{"small":_vm.small,"color":_vm.color,"close":_vm.clearable}},_vm.$listeners),[_vm._t("default"),(_vm.icon)?_c('v-icon',{attrs:{"left":!_vm.iconRight,"right":_vm.iconRight}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }